import React, { useEffect, useState } from 'react'
import { useRecoilState } from 'recoil'
import {
  InGameAccountModalState,
  selectCategoryProfileState,
} from '../../../../../common/atoms/checkout'
import { CategoryResponse } from '../../../../../types/categories/responses/category-response'
import { CategoryProfileResponse } from '../../../../../types/users/category-profile-response'
import { Dictionary } from '../../../../../types/collections/dictionary'
import { CategorySpecializedTag } from '../../../../../types/users/requests/category-specialized-tag-response'
import { InGameAccountModalStatusEnum } from '../../../../../common/enums/in-game-account-modal-status.enum'
import { usePutUpdateCategoryProfile } from '../../../../../hooks/users/usePutUpdateCategoryProfile'
import { GeneralCategoryRequest } from '../../../../../types/users/requests/general-category-request'
import { toast } from 'react-toastify'
import {
  ErrorResponse,
  readableError,
} from '../../../../../types/errors/responses/error-response'
import groupBy from 'lodash.groupby'

type Props = {
  game?: CategoryResponse
  profile: CategoryProfileResponse
  getProfile: any
}

export default function ProfileEditingCard({ profile, getProfile }: Props) {
  const [, setChosenId] = useRecoilState(selectCategoryProfileState)
  const [, setModalStatus] = useRecoilState(InGameAccountModalState)
  const {
    mutate: updateProfile,
    isSuccess: updateProfileSuccess,
    error,
  } = usePutUpdateCategoryProfile()

  useEffect(() => {
    if (updateProfileSuccess) {
      getProfile()
      setChosenId(-1)
    }
  }, [updateProfileSuccess])

  const [groupedProfile, setGroupedProfile] = useState<
    Dictionary<CategorySpecializedTag[]>
  >({})

  const handleCheckedChange = () => {
    let tempProfile: GeneralCategoryRequest = {
      isSelected: true,
      id: profile.id,
      categorySpecializedTags: undefined,
    }

    updateProfile(tempProfile)
  }

  useEffect(() => {
    if (error) {
      toast.error(readableError(error as ErrorResponse))
    }
  }, [error])

  useEffect(() => {
    if (profile?.categorySpecializedTags) {
      setGroupedProfile(
        groupBy(profile.categorySpecializedTags, (item) => item.parent.name),
      )
    }
  }, [profile])

  return (
    <div
      className={
        'flex h-14 flex-row items-center justify-between rounded-lg pl-4 pr-4'
      }
    >
      <div className={'flex flex-row items-center'}>
        <div className='relative h-0'>
          <input
            onChange={handleCheckedChange}
            id={profile.id + '_radio'}
            type='radio'
            value={profile.id}
            className='peer opacity-0'
            checked={profile.isSelected}
          />

          <label
            htmlFor={profile.id + '_radio'}
            className='absolute left-0 top-0 flex h-5 w-5 -translate-x-1/2 -translate-y-1/2 cursor-pointer rounded-full border border-gray-50 peer-checked:border-0 peer-checked:bg-fizz-1000'
          />

          <span className='broder hidden absolute left-0 top-0 h-2 w-2 -translate-x-1/2 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-white peer-checked:block'></span>
        </div>

        <div className={'ml-3 flex flex-col'}>
          <p
            className={
              'text-body-semibold w-40 truncate text-fizz-1000 md:w-52 font-sans'
            }
          >
            {profile.username}
          </p>

          <p
            className={
              'text-secondary-normal w-40 truncate text-gray-100 md:w-52'
            }
          >
            {groupedProfile['Regions']?.map((item) => {
              return item.name
            })}

            {groupedProfile['Roles']?.length > 0 && (
              <span className={'px-1'}>•</span>
            )}

            {groupedProfile['Roles']
              ?.sort((obj1, obj2) => obj1.id - obj2.id)
              ?.map((item) => {
                return item.name
              })
              ?.join(', ')}

            {/*{groupedProfile['Rank']?.length > 0 && (*/}
            {/*  <span className={'px-1'}>•</span>*/}
            {/*)}*/}

            {/*{groupedProfile['Rank']?.map((item) => {*/}
            {/*  return item.name*/}
            {/*})}*/}
          </p>
        </div>
      </div>

      <p
        onClick={() => {
          setChosenId(profile.id)
          setModalStatus(InGameAccountModalStatusEnum.EDIT)
        }}
        className={'text-body-bold cursor-pointer text-fizz-1000'}
      >
        Edit
      </p>
    </div>
  )
}
